export const getUserName = (name) => {
    const str = name.split(' ').join('');
    return str;    
}